import { roleConstants } from './roleConstants';
import {userConstants} from "../../../auth/_redux/authConstants";

const makeInitialState = () => ({
  requestActive: false,
  requestSaveActive: false,
  shouldReload: true,
  items: [],
  rowsPerPage: 10,
  page: 1,
  sortBy: "id",
  sortDirection: "desc",
  total: 0,
  error: '',
  query: "",
  inProgress: true,
});

export function acl_roles(state = makeInitialState(), action) {
  switch (action.type) {
    case userConstants.LOGOUT:
      return makeInitialState();
    case roleConstants.ACL_ROLE_LIST_REQUEST:
      return {
        ...state,
        requestActive: true,
        shouldReload: false,
        error: '',
        total: 0,
        inProgress: true,
      };
    case roleConstants.ACL_ROLE_LIST_SUCCESS:
      return {
        ...state,
        requestActive: false,
        shouldReload: false,
        items: action.roles.rows ? action.roles.rows : [],
        total: action.roles.total ? action.roles.total : 0,
        inProgress: false,
      };
    case roleConstants.ACL_ROLE_LIST_FAILURE:
      return {
        ...state,
        error: action.error,
        inProgress: false,
      };
    case roleConstants.ACL_ROLE_LIST_CHANGED:
      return {
        ...state,
        shouldReload: true,
      };
    case roleConstants.ACL_ROLE_LIST_PAGINATION: {
      let shouldReload = state.items.length === 0 ? true : false;

      if (state.rowsPerPage !== action.pagination.rowsPerPage
        || state.page !== action.pagination.page
        || state.sortBy !== action.pagination.sortBy
        || state.sortDirection !== action.pagination.sortDirection
        || state.query !== action.pagination.query
        || state.shouldReload) {
        shouldReload = true;
      }

      return {
        ...state,
        rowsPerPage: action.pagination.rowsPerPage,
        page: action.pagination.page,
        sortBy: action.pagination.sortBy,
        sortDirection: action.pagination.sortDirection,
        query: action.pagination.query,
        shouldReload
      };
    }

    case roleConstants.ACL_ROLE_SAVE_REQUEST:
      return {
        ...state,
        requestSaveActive: true,
      }
    case roleConstants.ACL_ROLE_SAVE_SUCCESS:
      if (action.isNew) {
        return {
          ...state,
          requestSaveActive: false,
          items: [...state.items, action.role],
        }
      }
      return {
        ...state,
        requestSaveActive: false,
        items: state.items.map(t => t.id === action.role.id ? action.role : t)
      }
    case roleConstants.ACL_ROLE_SAVE_FAILURE:
      return {
        ...state,
        requestSaveActive: false,
        error: action.error,
      }

    default:
      return state
  }
}
